/**
 * STRUGA Bridge — client-side handler для RU-витрины strugadesign.ru
 * =================================================================
 *
 * На strugadesign.ru (когда корзина/страна/локаль = RU) подменяет долларовый
 * Shopify-чекаут рублёвым чекаутом STRUGA на pay.strugadesign.ru.
 *
 * ЕДИНЫЙ ИСТОЧНИК ИСТИНЫ — Bitrix-корзина (pay.strugadesign.ru/api/cart,
 * привязка по cookie struga_cart_id). Нативный Shopify cart НЕ используется:
 * перехватываем «В корзину» / «Купить» / «Оформить» и работаем только со
 * своей корзиной. Это убирает рассинхрон, из-за которого Shopify cart
 * накапливал «мусорные» позиции, а «Купить» показывал не тот состав.
 *
 *  «В корзину»    → POST /api/cart/add.php → справа выезжает фирменная
 *                   панель STRUGA (drawer) с составом корзины в рублях.
 *  «Купить»       → POST /api/cart/add.php (этот товар) → /cart/checkout.php.
 *  иконка корзины → открывает ту же выдвижную панель.
 *  в панели       → изменение количества / удаление через /api/cart/*.php.
 *  «Оформить»     → POST /cart/checkout.php → Bitrix Order → /checkout/.
 *
 * Конвертация корзины в заказ — ОДИН путь: /cart/checkout.php. Корзина живёт
 * до оплаты и очищается строго по факту оплаты (вебхук ЮKassa). Поэтому
 * «Назад» со страницы оплаты сохраняет состав, а оплаченное не висит в корзине.
 *
 * Страница /cart/ на pay.strugadesign.ru остаётся как fallback для прямого
 * захода по ссылке — drawer её не отменяет.
 *
 * Активация — только RU-витрина (window.STRUGA_BRIDGE_CONFIG.enabled).
 * На strugadesign.com / EN всё это выключено, работает штатный Shopify.
 */

(function () {
  'use strict';

  var cfg = window.STRUGA_BRIDGE_CONFIG || {};
  var CURRENT_HOST = '';
  try {
    CURRENT_HOST = String(window.location.hostname || '')
      .toLowerCase().replace(/\.$/, '');
    if (!CURRENT_HOST && window.location.href) {
      CURRENT_HOST = String(new URL(window.location.href).hostname || '')
        .toLowerCase().replace(/\.$/, '');
    }
  } catch (e) {}
  // Liquid already gates by request.host. The asset repeats the exact-domain
  // boundary so a configuration regression still cannot affect .com.
  if (!cfg.enabled || CURRENT_HOST !== 'strugadesign.ru') {
    if (cfg.debug) console.log('[STRUGA Bridge] disabled (domain/config gate)');
    return;
  }

  var CART_API      = cfg.cart_api || 'https://pay.strugadesign.ru/api/cart';
  var CART_PAGE     = cfg.cart_page || 'https://pay.strugadesign.ru/cart/';
  // Конвертация корзины в заказ — отдельный endpoint (POST-форма, double-submit CSRF).
  var CART_CHECKOUT = cfg.cart_checkout || 'https://pay.strugadesign.ru/cart/checkout.php';
  var SHOP          = cfg.shop || '141054.myshopify.com';
  var SHOP_URL      = 'https://strugadesign.ru/collections/all';
  var DEBUG         = !!cfg.debug;
  var INSTALLED     = false;

  // CSRF-токен корзины. Получаем через GET /api/cart/get.php (он же ставит cookie).
  var cartCsrf = null;

  function log() {
    if (DEBUG) console.log.apply(console, ['[STRUGA Bridge]'].concat([].slice.call(arguments)));
  }

  // --- Телеметрия воронки (аддитивно): ecommerce-события в dataLayer.
  // Счётчик Метрики инициализирован ecommerce:"dataLayer" → попадает в отчёт
  // «Электронная коммерция» и авто-цель e_cart. Ошибки телеметрии гасятся,
  // на логику корзины/оплаты НЕ влияют.
  var ALLOWED_BROWSER_EVENTS = {
    add_to_cart: true,
    view_cart: true,
    remove_from_cart: true
  };

  // Exactly one consumer path per mutation event: canonical GA4 gtag when it
  // exists and accepts the call; otherwise the pre-existing Yandex ecommerce
  // add/remove action is used as a fallback. No payload or identifier is logged.
  function dispatchCommerceEvent(eventName, gaPayload, yandexFallback) {
    if (!Object.prototype.hasOwnProperty.call(ALLOWED_BROWSER_EVENTS, eventName)) return false;
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', eventName, gaPayload);
        return true;
      } catch (e) {}
    }
    if (yandexFallback) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: yandexFallback });
        return true;
      } catch (e) {}
    }
    return false;
  }

  function safeCommerceItem(item, quantityOverride) {
    item = item || {};
    var itemId = String(item.variant_id || item.item_id || item.id || '');
    var quantity = quantityOverride == null
      ? (parseInt(item.quantity, 10) || 0)
      : (parseInt(quantityOverride, 10) || 0);
    if (!/^\d+$/.test(itemId) || quantity <= 0) return null;
    // 20.08.2026: кроме идентификатора отдаём ИМЯ и ЦЕНУ, если корзина их дала.
    // Прежде уходил только item_id, и в отчётах русская витрина показывала товар
    // как «(not set)» — нельзя было понять, ЧТО кладут в корзину и на какую сумму.
    // Ничего не выдумываем: поля берутся из ответа корзины (те же, которыми
    // рисуется ящик), а отсутствующие просто не добавляются.
    var out = { item_id: itemId, quantity: quantity };
    var name = item.name || item.product_name || '';
    if (typeof name === 'string' && name) out.item_name = name;
    var price = item.price_rub != null ? item.price_rub : item.price;
    var priceNum = parseFloat(price);
    if (isFinite(priceNum) && priceNum > 0) out.price = priceNum;
    return out;
  }

  function safeCartItems(cart) {
    var source = cart && Array.isArray(cart.items) ? cart.items : [];
    var items = [];
    for (var n = 0; n < source.length && n < 50; n++) {
      var safe = safeCommerceItem(source[n]);
      if (safe) items.push(safe);
    }
    return items;
  }

  function cartItemByVariantId(cart, variantId) {
    // При ДОБАВЛЕНИИ нового товара внутренний номер позиции ещё не известен,
    // и поиск по нему возвращает пусто — поэтому событие уходило без имени и
    // цены (поймано живым прогоном 20.08). Ищем по варианту: он известен всегда.
    var source = cart && Array.isArray(cart.items) ? cart.items : [];
    var нужен = String(variantId || '');
    if (!нужен) return null;
    for (var n = 0; n < source.length; n++) {
      var v = String(source[n].variant_id || source[n].item_id || source[n].id || '');
      if (v === нужен) return source[n];
    }
    return null;
  }

  function cartItemByBasketId(cart, basketId) {
    var source = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var n = 0; n < source.length; n++) {
      if ((parseInt(source[n].basket_id, 10) || 0) === basketId) return source[n];
    }
    return null;
  }

  function trackAddToCart(item, quantity) {
    var safe = safeCommerceItem(item, quantity);
    if (!safe) return false;
    return dispatchCommerceEvent(
      'add_to_cart',
      { currency: 'RUB', items: [safe] },
      { currencyCode: 'RUB', add: { products: [{ id: safe.item_id, quantity: safe.quantity }] } }
    );
  }

  function trackRemoveFromCart(item, quantity) {
    var safe = safeCommerceItem(item, quantity);
    if (!safe) return false;
    return dispatchCommerceEvent(
      'remove_from_cart',
      { currency: 'RUB', items: [safe] },
      { currencyCode: 'RUB', remove: { products: [{ id: safe.item_id, quantity: safe.quantity }] } }
    );
  }

  function trackViewCart(cart, directRoute) {
    // A direct route has no authoritative snapshot yet. Emit minimal context;
    // never invent cart items or value merely because /cart was requested.
    var payload = directRoute
      ? { currency: 'RUB', cart_surface: 'direct_route' }
      : { currency: 'RUB', items: safeCartItems(cart), cart_surface: 'drawer' };
    return dispatchCommerceEvent('view_cart', payload, null);
  }

  // ViewIntent: one intent for one closed->open drawer lifecycle. Requests in
  // the same open reuse the token. Close/Escape/bfcache invalidates it.
  var viewIntentSequence = 0;
  var activeViewIntent = null;

  function ensureViewIntent() {
    if (!activeViewIntent || activeViewIntent.state === 'CLOSED') {
      activeViewIntent = {
        token: ++viewIntentSequence,
        surface: 'drawer',
        state: 'PENDING',
        request: 0
      };
    }
    return activeViewIntent;
  }

  function invalidateViewIntent() {
    if (activeViewIntent) activeViewIntent.state = 'CLOSED';
    activeViewIntent = null;
  }

  function beginViewRequest() {
    var intent = ensureViewIntent();
    intent.request += 1;
    return { token: intent.token, request: intent.request };
  }

  function viewHandleIsCurrent(handle) {
    return !!(
      handle && activeViewIntent &&
      activeViewIntent.token === handle.token &&
      activeViewIntent.request === handle.request &&
      activeViewIntent.state !== 'CLOSED'
    );
  }

  function completeViewRequest(handle, cart, renderFn) {
    if (!viewHandleIsCurrent(handle)) return false;
    var firstSnapshot = activeViewIntent.state === 'PENDING';
    if (firstSnapshot) activeViewIntent.state = 'EMITTED';
    if (firstSnapshot) trackViewCart(cart, false);
    if (typeof renderFn === 'function') renderFn(cart);
    return true;
  }

  function failViewRequest(handle, failureFn) {
    if (!viewHandleIsCurrent(handle)) return false;
    // PENDING is retained. A same-open retry may still emit exactly once.
    if (typeof failureFn === 'function') failureFn();
    return true;
  }

  function completeMutationSnapshot(viewToken, cart, renderFn) {
    if (!activeViewIntent || activeViewIntent.token !== viewToken) return false;
    // A mutation response is authoritative for its own view. Invalidate older
    // snapshot requests in this same intent before rendering it.
    activeViewIntent.request += 1;
    var firstSnapshot = activeViewIntent.state === 'PENDING';
    if (firstSnapshot) activeViewIntent.state = 'EMITTED';
    if (firstSnapshot) trackViewCart(cart, false);
    if (typeof renderFn === 'function') renderFn(cart);
    return true;
  }

  // MutationReceipt: basket correlation remains private state. A successful
  // API response commits the receipt before fail-open telemetry dispatch.
  var mutationReceiptSequence = 0;
  function beginMutationReceipt(kind, basketId, preItem, requestedDelta) {
    var safePre = preItem ? {
      variant_id: String(preItem.variant_id || ''),
      quantity: parseInt(preItem.quantity, 10) || 0
    } : null;
    var normalizedRequested = parseInt(requestedDelta, 10) || 0;
    // add.php normalizes the effective requested quantity to the same 1..25
    // interval; the receipt mirrors that request contract deterministically.
    if (kind === 'add') {
      if (normalizedRequested < 1) normalizedRequested = 1;
      if (normalizedRequested > 25) normalizedRequested = 25;
    }
    return {
      id: ++mutationReceiptSequence,
      state: 'PENDING',
      kind: kind,
      basketId: parseInt(basketId, 10) || 0,
      preItem: safePre,
      requestedDelta: normalizedRequested,
      viewToken: activeViewIntent ? activeViewIntent.token : null
    };
  }

  function failMutationReceipt(receipt) {
    if (receipt && receipt.state === 'PENDING') receipt.state = 'FAILED';
  }

  function commitMutationReceipt(receipt, postCart) {
    if (!receipt || receipt.state !== 'PENDING') return null;
    receipt.state = 'COMMITTED';

    var preQuantity = receipt.preItem ? receipt.preItem.quantity : 0;
    var postItem = receipt.basketId > 0
      ? cartItemByBasketId(postCart, receipt.basketId)
      : null;
    var postQuantity = postItem ? (parseInt(postItem.quantity, 10) || 0) : 0;
    var delta = 0;
    var eventItem = postItem || receipt.preItem;

    if (receipt.kind === 'add') {
      delta = receipt.requestedDelta;
      // 20.08.2026: описание позиции берём из СВЕЖЕЙ корзины (postItem), а не из
      // состояния до добавления — там ещё нет ни имени, ни цены, и в отчётах
      // русская витрина показывала товар как «(not set)». Количество события
      // по-прежнему приходит отдельным аргументом delta, поэтому подмена
      // источника описания на него не влияет.
      var базовый = receipt.preItem || {};
      eventItem = postItem
        || cartItemByVariantId(postCart, базовый.variant_id || базовый.item_id || базовый.id)
        || receipt.preItem;
    } else if (receipt.kind === 'update') {
      delta = receipt.preItem && postItem ? (postQuantity - preQuantity) : 0;
    } else if (receipt.kind === 'remove') {
      delta = preQuantity > postQuantity ? -(preQuantity - postQuantity) : 0;
    }

    if (delta > 0) trackAddToCart(eventItem, delta);
    if (delta < 0) trackRemoveFromCart(eventItem, -delta);
    return { state: receipt.state, delta: delta };
  }

  var directCartIntentUsed = false;
  function isDirectRuCartRoute(locationObject) {
    try {
      if (CURRENT_HOST !== 'strugadesign.ru') return false;
      return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(
        String(locationObject.pathname || '')
      );
    } catch (e) { return false; }
  }

  var ruCartPageMode = false;
  function routeDirectRuCart() {
    if (directCartIntentUsed || !isDirectRuCartRoute(window.location)) return false;
    directCartIntentUsed = true;
    trackViewCart(null, true);
    // 30.07.2026. Раньше здесь был мгновенный переброс на pay.strugadesign.ru/cart/ —
    // покупатель терял фирменную страницу корзины (решение Дмитрия: вернуть её).
    // Урок 27.07: та попытка возвращала true, мост не устанавливался и кнопка
    // «Оформить заказ» умирала. Теперь режим страницы лишь помечается, установка
    // моста идёт полностью, зеркалирование стартует ПОСЛЕ install().
    ruCartPageMode = true;
    return false;
  }

  // Run before pageshow/DOM listeners, cart API reads, form construction and
  // native-cart clearing. Function declarations below are hoisted; no setup
  // side effect has occurred at this point.
  if (routeDirectRuCart()) return;

  // ===========================================================================
  //  ОБЩЕЕ
  // ===========================================================================

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // Рубли: целое число → "16 000 ₽" (неразрывные пробелы как на витрине).
  function formatRub(rub) {
    var n = parseInt(rub, 10);
    if (!n || n < 0) n = 0;
    var s = String(n), out = '';
    while (s.length > 3) { out = ' ' + s.slice(-3) + out; s = s.slice(0, -3); }
    return s + out + ' ₽';
  }

  // Склонение «товар / товара / товаров».
  function itemsWord(n) {
    n = parseInt(n, 10) || 0;
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return 'товар';
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return 'товара';
    return 'товаров';
  }

  // ===========================================================================
  //  A) ПЕРЕХОД К ОПЛАТЕ — занавес «светлое растворение» + /cart/checkout.php
  // ===========================================================================
  // Кросс-доменный переход витрина↔оформление неизбежно перезагружает страницу.
  // Чтобы это не выглядело рывком — на момент перехода экран накрывает мягкий
  // кремовый занавес со знаком STRUGA. Такой же занавес отрисован и на
  // pay.strugadesign.ru, поэтому переход туда-обратно читается как один кадр.
  // «Назад» с оформления: страница берётся из памяти браузера вместе с уже
  // поднятым занавесом — его остаётся только плавно растворить (см. pageshow).

  var curtainEl = null;

  function injectCurtainStyles() {
    if (document.getElementById('struga-curtain-style')) return;
    var s = document.createElement('style');
    s.id = 'struga-curtain-style';
    s.textContent = [
      '.struga-curtain{position:fixed;inset:0;z-index:2147483646;background:#f3f1ea;',
      'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;',
      'font-family:"Jost",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'opacity:0;pointer-events:none;transition:opacity .34s ease;-webkit-font-smoothing:antialiased}',
      '.struga-curtain.is-visible{opacity:1;pointer-events:auto}',
      '.struga-curtain__mark{font-size:13px;font-weight:400;letter-spacing:.44em;',
      'text-transform:uppercase;color:#1a1a1a;padding-left:.44em}',
      '.struga-curtain__line{width:44px;height:1px;background:#d8d3c6;position:relative;overflow:hidden}',
      '.struga-curtain__line::after{content:"";position:absolute;top:0;bottom:0;left:-45%;width:45%;',
      'background:#1a1a1a;animation:struga-curtain-sweep 1.15s ease-in-out infinite}',
      '@keyframes struga-curtain-sweep{0%{left:-45%}100%{left:100%}}',
      '@media(prefers-reduced-motion:reduce){',
      '.struga-curtain{transition-duration:.01s}',
      '.struga-curtain__line::after{animation:none;left:0;width:100%}}'
    ].join('');
    document.head.appendChild(s);
  }

  function buildCurtain() {
    if (curtainEl) return curtainEl;
    injectCurtainStyles();
    curtainEl = document.createElement('div');
    curtainEl.className = 'struga-curtain';
    curtainEl.id = 'struga-curtain';
    curtainEl.setAttribute('role', 'status');
    curtainEl.setAttribute('aria-live', 'polite');
    curtainEl.setAttribute('aria-label', 'Переход к оформлению');
    curtainEl.innerHTML =
      '<div class="struga-curtain__mark">STRUGA</div>' +
      '<div class="struga-curtain__line" aria-hidden="true"></div>';
    document.body.appendChild(curtainEl);
    return curtainEl;
  }

  // Плавно проявить занавес. Promise resolve — когда он полностью непрозрачен,
  // т.е. кросс-доменную загрузку уже можно делать за непрозрачным экраном.
  function showCurtain() {
    var el = buildCurtain();
    el.style.transitionDuration = ''; // .34s из CSS
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var done = false;
          var finish = function () { if (!done) { done = true; resolve(); } };
          el.addEventListener('transitionend', finish, { once: true });
          setTimeout(finish, 460); // страховка, если transitionend не придёт
          el.classList.add('is-visible');
        });
      });
    });
  }

  // Плавно растворить занавес (чуть мягче проявления).
  function hideCurtain() {
    if (!curtainEl) return;
    curtainEl.style.transitionDuration = '.46s';
    curtainEl.classList.remove('is-visible');
  }

  // Submit скрытой формы на /cart/checkout.php — конвертация Bitrix-корзины
  // в Bitrix Order. fetch не умеет навигировать по cross-origin 302, поэтому
  // уходим обычным POST-сабмитом формы — браузер сам перейдёт на /checkout/.
  // Cookie корзины (struga_cart_id, struga_cart_csrf) — SameSite=None, браузер
  // пришлёт их и при cross-site top-level navigation.
  // GA4/Метрика кросс-доменная атрибуция (аддитивно): client_id GA4 живёт в
  // cookie `_ga` на strugadesign.ru (Shopify-витрина) и НЕ виден на
  // pay.strugadesign.ru (другой поддомен). Пробрасываем его (и `_ym_uid` Метрики)
  // скрытыми полями POST-формы оформления → мост сохранит в заказ → серверный
  // purchase в callback свяжет .ru-продажу с исходным каналом. Сбой чтения
  // cookie оформление не ломает — поля просто не добавятся.

// --- Первый источник покупателя (аддитивно, 03.09.2026) ---------------------
// Мост пишет в заказ только HTTP_REFERER, а это всегда страница корзины: за
// июль-август ни один из 42 заказов не получил внешнего источника. Запоминаем
// ПЕРВЫЙ переход и метки кампании при самом раннем заходе и отдаём их форме
// оформления. Первый источник не перезаписываем: он объясняет, откуда человек
// узнал о бренде, тогда как последний почти всегда «прямой заход».
function strugaFirstSource(){
  var KEY="struga_first_src";
  try{
    var saved=window.localStorage.getItem(KEY);
    if(saved){return JSON.parse(saved)}
    var out={},q=null;
    try{q=new URLSearchParams(window.location.search)}catch(e){}
    if(q){["utm_source","utm_medium","utm_campaign"].forEach(function(k){
      var v=q.get(k);if(v){out[k]=String(v).slice(0,64)}
    })}
    var ref=String(document.referrer||"");
    if(ref&&ref.indexOf("strugadesign.ru")===-1&&ref.indexOf("pay.strugadesign.ru")===-1){
      out.first_referrer=ref.slice(0,180);
    }
    if(!Object.keys(out).length){return null}
    out.saved_at=new Date().toISOString().slice(0,10);
    window.localStorage.setItem(KEY,JSON.stringify(out));
    return out;
  }catch(e){return null}
}
try{strugaFirstSource()}catch(e){}

  function readCookie(name) {
    try {
      var safe = name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1');
      var m = document.cookie.match('(?:^|; )' + safe + '=([^;]*)');
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  // `_ga` = "GA1.<n>.<client_id>", где client_id = "X.Y". Снимаем префикс GAx.n.
  function ga4ClientId() {
    var raw = readCookie('_ga');
    if (!raw) return '';
    var cid = raw.replace(/^GA\d+\.\d+\./, '');
    return /^\d+\.\d+$/.test(cid) ? cid : '';
  }

  // Навигация может оборвать браузерную отправку события. Поэтому ждём callbacks
  // GA4/Метрики, но не задерживаем покупателя дольше жёсткого лимита. Повторный
  // клик использует тот же Promise: одно событие на одну загрузку страницы.
  var beginCheckoutPromise = null;
  function trackBeginCheckout() {
    if (beginCheckoutPromise) return beginCheckoutPromise;

    beginCheckoutPromise = new Promise(function (resolve) {
      var hasGtag = typeof window.gtag === 'function';
      var hasMetrika = typeof window.ym === 'function';
      var pending = (hasGtag ? 1 : 0) + (hasMetrika ? 1 : 0);
      var finished = false;
      var timer = null;

      function finish() {
        if (finished) return;
        finished = true;
        if (timer) clearTimeout(timer);
        resolve();
      }
      function oneSent() {
        pending -= 1;
        if (pending <= 0) finish();
      }

      // 400 ms — верхняя граница ожидания телеметрии; checkout не зависит от неё.
      timer = setTimeout(finish, 400);
      if (!pending) {
        finish();
        return;
      }

      if (hasGtag) {
        try {
          window.gtag('event', 'begin_checkout', {
            currency: 'RUB',
            checkout_surface: 'ru_bridge',
            event_callback: oneSent,
            event_timeout: 350
          });
        } catch (e) { oneSent(); }
      }

      if (hasMetrika) {
        try {
          window.ym(108771804, 'reachGoal', 'begin_checkout_ru', {
            checkout_surface: 'ru_bridge'
          }, oneSent);
        } catch (e) { oneSent(); }
      }
    });

    return beginCheckoutPromise;
  }
  function submitCartCheckout() {
    return ensureCartCsrf().then(function (csrf) {
      if (!csrf) throw new Error('no_csrf');
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = CART_CHECKOUT;
      f.style.display = 'none';
      f.acceptCharset = 'UTF-8';
      var i1 = document.createElement('input');
      i1.type = 'hidden'; i1.name = 'cart_csrf'; i1.value = csrf;
      f.appendChild(i1);
      // Куда вернуть со страницы оформления — карточка, откуда ушли.
      var i2 = document.createElement('input');
      i2.type = 'hidden'; i2.name = 'return_url'; i2.value = window.location.href;
      f.appendChild(i2);
      // GA4 client_id + Метрика _ym_uid — серверная атрибуция .ru-покупки.
      var cid = ga4ClientId();
      if (cid) {
        var i3 = document.createElement('input');
        i3.type = 'hidden'; i3.name = 'ga4_cid'; i3.value = cid;
        f.appendChild(i3);
      }
      var ym = readCookie('_ym_uid');
      if (ym && /^\d+$/.test(ym)) {
        var i4 = document.createElement('input');
        i4.type = 'hidden'; i4.name = 'ym_uid'; i4.value = ym;
        f.appendChild(i4);
      }
      // Первый источник покупателя — метки кампании и внешний переход.
      var firstSrc = strugaFirstSource();
      if (firstSrc) {
        ['utm_source', 'utm_medium', 'utm_campaign', 'first_referrer'].forEach(function (k) {
          if (!firstSrc[k]) { return; }
          var ix = document.createElement('input');
          ix.type = 'hidden'; ix.name = k; ix.value = String(firstSrc[k]).slice(0, 180);
          f.appendChild(ix);
        });
      }
      document.body.appendChild(f);
      // Даже в debug не выводим аналитические идентификаторы посетителя.
      log('submitting cart checkout', cid ? 'cid=1' : 'no-cid', ym ? 'ym=1' : 'no-ym');
      return trackBeginCheckout().then(function () { f.submit(); });
    });
  }

  // «Оформить» всей корзины (ссылка на /checkout, кнопка name=checkout).
  // Пустую корзину /cart/checkout.php сам развернёт на /cart/?error=empty.
  function goToCartCheckout() {
    showCurtain()
      .then(function () { return reconcileRuCartBeforeCheckout(); })
      .then(function () { return submitCartCheckout(); })
      .catch(function (err) {
        hideCurtain();
        console.error('[STRUGA Bridge] checkout failed:', err);
        showErrorToast('Не удалось перейти к оформлению. Обновите страницу.');
      });
  }

  // «Купить» / «Buy it now» на карточке товара: добавляем ИМЕННО этот товар
  // в Bitrix-корзину и сразу уходим на оформление. Shopify cart не трогаем.
  function buyNow(form, submitterBtn) {
    var fd = new FormData(form);
    var variantId = fd.get('id');
    var quantity = parseInt(fd.get('quantity') || 1, 10) || 1;
    if (!variantId) {
      log('buyNow: no variant id — fallback to cart checkout');
      goToCartCheckout();
      return;
    }
    // Кастомные свойства строки (properties[...]) — гравировка, записка и т.п.
    var propsObj = {};
    fd.forEach(function (v, k) {
      if (k.indexOf('properties[') === 0 && typeof v === 'string') {
        var pm = k.match(/^properties\[(.+)\]$/);
        if (pm) propsObj[pm[1]] = v;
      }
    });

    var btnBusyCleanup = markButtonBusy(submitterBtn);
    var curtainReady = showCurtain();
    var mutation = beginMutationReceipt(
      'add', 0, { variant_id: String(variantId), quantity: 0 }, quantity
    );

    cartApiPost('add.php', {
      variant_id: String(variantId),
      quantity: quantity,
      properties: propsObj
    })
      .then(function (data) {
        commitMutationReceipt(mutation, data.cart);
        applyMutationSnapshot(mutation, data.cart);
        // Уходим только когда занавес полностью проявился — кросс-доменная
        // загрузка случится за непрозрачным экраном.
        return curtainReady;
      })
      .then(function () {
        return submitCartCheckout();
      })
      .catch(function (err) {
        failMutationReceipt(mutation);
        btnBusyCleanup();
        hideCurtain();
        console.error('[STRUGA Bridge] buyNow failed:', err);
        if (err && err.httpStatus === 409) {
          showErrorToast(err.message || 'Товара нет в наличии');
        } else {
          showErrorToast('Не удалось перейти к оформлению. Попробуйте ещё раз.');
        }
      });
  }

  // ===========================================================================
  //  B) КАСТОМНАЯ КОРЗИНА В РУБЛЯХ — API-слой
  // ===========================================================================

  // ---- CSRF: получить токен корзины (одноразово, кэшируем) ----
  function ensureCartCsrf() {
    if (cartCsrf) return Promise.resolve(cartCsrf);
    return fetch(CART_API + '/get.php', { method: 'GET', credentials: 'include', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.csrf) {
          cartCsrf = data.csrf;
          if (data.cart) updateCartBadge(data.cart.items_count);
        }
        return cartCsrf;
      })
      .catch(function () { return null; });
  }

  // ---- GET снимок корзины (для открытия drawer по иконке) ----
  function cartApiGet() {
    return fetch(CART_API + '/get.php', { method: 'GET', credentials: 'include', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.csrf) cartCsrf = data.csrf;
        if (!data || !data.success) throw new Error('cart_get_failed');
        return data.cart || { items: [], items_count: 0, total_rub: 0 };
      });
  }

  // ---- POST в наш cart API (add/update/remove) ----
  // The server returns a whole-cart snapshot after every mutation. Starting
  // two writes concurrently makes their application order unknowable to the
  // browser, so a client-side response generation cannot prove which snapshot
  // is authoritative. Serialize mutation starts instead: one request fully
  // settles before the next reaches the server. The tail is always recovered
  // to a fulfilled promise so one failed write cannot poison later actions.
  var cartMutationTail = Promise.resolve();

  function performCartApiPost(endpoint, payload) {
    return ensureCartCsrf().then(function (csrf) {
      return fetch(CART_API + '/' + endpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Struga-Cart-CSRF': csrf || ''
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || !data.success) {
            var msg = (data && data.message) ? data.message : 'Не удалось обновить корзину';
            var e = new Error(msg);
            e.httpStatus = r.status;
            throw e;
          }
          return data;
        });
      });
    });
  }

  function cartApiPost(endpoint, payload) {
    var operation = cartMutationTail.then(function () {
      return performCartApiPost(endpoint, payload);
    });
    cartMutationTail = operation.then(
      function () { return null; },
      function () { return null; }
    );
    return operation;
  }

  // ---- Счётчик корзины в шапке (синхронизируем с нашей корзиной) ----
  function updateCartBadge(count) {
    count = parseInt(count, 10) || 0;
    // Тема Ecom: <span class="count" data-header-cart-count>
    var nodes = document.querySelectorAll('[data-header-cart-count], .cart-count, .header-cart-count');
    nodes.forEach(function (n) { n.textContent = String(count); });
  }

  // ===========================================================================
  //  B) ВЫДВИЖНАЯ ПАНЕЛЬ КОРЗИНЫ (drawer)
  // ===========================================================================

  // Стили drawer. Инжектируем один раз. Фирменный стиль STRUGA:
  // Jost, чёрно-белый минимализм, тонкие линии — как страница /cart/.
  function injectDrawerStyles() {
    if (document.getElementById('struga-cart-drawer-style')) return;
    var s = document.createElement('style');
    s.id = 'struga-cart-drawer-style';
    s.textContent = [
      // --- оверлей-затемнение ---
      '.struga-cd-overlay{position:fixed;inset:0;background:rgba(20,20,20,0);',
      'z-index:2147483640;opacity:0;pointer-events:none;',
      'transition:background-color .32s ease,opacity .32s ease}',
      '.struga-cd-overlay.is-open{background:rgba(20,20,20,0.42);opacity:1;pointer-events:auto}',
      // --- сама панель ---
      '.struga-cd{position:fixed;top:0;right:0;bottom:0;width:420px;max-width:100vw;',
      'background:#fff;z-index:2147483641;display:flex;flex-direction:column;',
      'font-family:"Jost",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'color:#1a1a1a;box-shadow:-12px 0 48px rgba(0,0,0,0.16);',
      'transform:translateX(100%);transition:transform .36s cubic-bezier(.22,1,.36,1);',
      '-webkit-font-smoothing:antialiased;will-change:transform}',
      '.struga-cd.is-open{transform:translateX(0)}',
      '.struga-cd *{box-sizing:border-box}',
      // --- шапка ---
      '.struga-cd__head{display:flex;align-items:center;justify-content:space-between;',
      'padding:22px 24px 18px;border-bottom:1px solid #ececec;flex-shrink:0}',
      '.struga-cd__title{font-size:13px;font-weight:600;letter-spacing:.18em;',
      'text-transform:uppercase;margin:0}',
      '.struga-cd__count{font-size:11px;color:#9a9a9a;letter-spacing:.04em;margin-left:10px;font-weight:400}',
      '.struga-cd__close{border:0;background:none;cursor:pointer;color:#1a1a1a;',
      'width:32px;height:32px;display:flex;align-items:center;justify-content:center;',
      'margin:-6px -8px -6px 0;padding:0;transition:opacity .15s ease}',
      '.struga-cd__close:hover{opacity:.55}',
      '.struga-cd__close svg{width:18px;height:18px}',
      // --- тело со скроллом ---
      '.struga-cd__body{flex:1 1 auto;overflow-y:auto;overflow-x:hidden;',
      '-webkit-overflow-scrolling:touch;padding:4px 0}',
      // --- позиция ---
      '.struga-cd-line{display:grid;grid-template-columns:150px 1fr;gap:16px;',
      'padding:18px 24px;border-bottom:1px solid #f1f1f1;position:relative}',
      '.struga-cd-line:last-child{border-bottom:0}',
      '.struga-cd-line__img{width:150px;height:150px;border:1px solid #ececec;',
      'background:#f4f4f4;object-fit:cover;display:block}',
      '@media(max-width:480px){.struga-cd-line{grid-template-columns:132px 1fr;gap:12px;padding:16px 18px}.struga-cd-line__img{width:132px;height:132px}}',
      '.struga-cd-line__img--ph{display:flex;align-items:center;justify-content:center;',
      'font-size:8px;letter-spacing:.1em;color:#bcbcbc;text-transform:uppercase}',
      '.struga-cd-line__body{min-width:0;display:flex;flex-direction:column;gap:6px}',
      '.struga-cd-line__name{font-size:13px;font-weight:500;line-height:1.4;margin:0;',
      'color:#1a1a1a;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;',
      '-webkit-box-orient:vertical;overflow:hidden}',
      'a.struga-cd-line__name:hover{text-decoration:underline}',
      '.struga-cd-line__unit{font-size:11px;color:#9a9a9a;letter-spacing:.03em}',
      '.struga-cd-line__row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:2px}',
      // степпер количества
      '.struga-cd-qty{display:inline-flex;align-items:center;border:1px solid #d8d8d8}',
      '.struga-cd-qty__btn{width:30px;height:30px;border:0;background:#fff;cursor:pointer;',
      'font-size:15px;line-height:1;color:#1a1a1a;display:flex;align-items:center;',
      'justify-content:center;padding:0;transition:background .12s ease}',
      '.struga-cd-qty__btn:hover{background:#f4f4f4}',
      '.struga-cd-qty__btn:disabled{color:#cfcfcf;cursor:default;background:#fff}',
      '.struga-cd-qty__val{min-width:34px;text-align:center;font-size:13px;font-weight:500;',
      'border-left:1px solid #d8d8d8;border-right:1px solid #d8d8d8;line-height:30px}',
      '.struga-cd-line__price{font-size:13px;font-weight:600;white-space:nowrap}',
      '.struga-cd-line__remove{border:0;background:none;cursor:pointer;padding:0;',
      'font-size:11px;color:#9a9a9a;letter-spacing:.03em;text-decoration:underline;',
      'text-underline-offset:2px;transition:color .12s ease;font-family:inherit}',
      '.struga-cd-line__remove:hover{color:#1a1a1a}',
      // занятость строки (во время update/remove)
      '.struga-cd-line.is-busy{opacity:.45;pointer-events:none}',
      // --- пустая корзина ---
      '.struga-cd-empty{flex:1;display:flex;flex-direction:column;align-items:center;',
      'justify-content:center;text-align:center;padding:48px 32px;gap:14px}',
      '.struga-cd-empty__mark{font-size:11px;letter-spacing:.32em;color:#cfcfcf;',
      'text-transform:uppercase}',
      '.struga-cd-empty__title{font-size:16px;font-weight:500;margin:0;color:#1a1a1a}',
      '.struga-cd-empty__text{font-size:12px;line-height:1.6;color:#9a9a9a;margin:0;max-width:240px}',
      '.struga-cd-empty__btn{margin-top:6px;display:inline-block;font-size:11px;font-weight:600;',
      'letter-spacing:.12em;text-transform:uppercase;text-decoration:none;color:#fff;',
      'background:#1a1a1a;padding:13px 26px;transition:opacity .14s ease}',
      '.struga-cd-empty__btn:hover{opacity:.82}',
      // --- подвал ---
      '.struga-cd__foot{flex-shrink:0;border-top:1px solid #ececec;padding:18px 24px 22px;',
      'background:#fff}',
      '.struga-cd__row{display:flex;align-items:center;justify-content:space-between;',
      'font-size:12px;color:#707070;margin-bottom:8px}',
      '.struga-cd__total{display:flex;align-items:baseline;justify-content:space-between;',
      'padding-top:10px;border-top:1px solid #f1f1f1;margin-bottom:4px}',
      '.struga-cd__total-label{font-size:12px;font-weight:600;letter-spacing:.06em;',
      'text-transform:uppercase}',
      '.struga-cd__total-value{font-size:19px;font-weight:600}',
      '.struga-cd__note{font-size:11px;color:#9a9a9a;margin:2px 0 14px;letter-spacing:.02em}',
      '.struga-cd__checkout{display:block;width:100%;border:0;background:#1a1a1a;color:#fff;',
      'font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.12em;',
      'text-transform:uppercase;padding:16px;cursor:pointer;text-align:center;',
      'transition:opacity .14s ease}',
      '.struga-cd__checkout:hover{opacity:.85}',
      '.struga-cd__checkout:disabled{opacity:.5;cursor:default}',
      '.struga-cd__continue{display:block;width:100%;margin-top:10px;border:0;background:none;',
      'font-family:inherit;font-size:11px;font-weight:500;letter-spacing:.06em;color:#707070;',
      'cursor:pointer;text-align:center;padding:8px;text-decoration:underline;',
      'text-underline-offset:2px;transition:color .12s ease}',
      '.struga-cd__continue:hover{color:#1a1a1a}',
      // --- общий спиннер на панели (загрузка снимка) ---
      '.struga-cd__loading{flex:1;display:flex;align-items:center;justify-content:center;padding:60px 0}',
      '.struga-cd__spinner{width:26px;height:26px;border:2px solid #1a1a1a;',
      'border-top-color:transparent;border-radius:50%;animation:struga-cd-spin .8s linear infinite}',
      '@keyframes struga-cd-spin{to{transform:rotate(360deg)}}',
      // блокируем скролл фона когда панель открыта
      'html.struga-cd-locked,body.struga-cd-locked{overflow:hidden!important}',
      // --- мобильная версия: на всю ширину, крупные тач-контролы ---
      '@media(max-width:480px){',
      '.struga-cd{width:100vw;max-width:100vw}',
      '.struga-cd__head{padding:18px 18px 16px}',
      '.struga-cd-line{padding:18px;gap:12px}',
      '.struga-cd-qty__btn{width:44px;height:44px;font-size:18px}',
      '.struga-cd-qty__val{min-width:44px;line-height:44px;font-size:15px}',
      '.struga-cd-line__remove{font-size:12px;padding:6px 0}',
      '.struga-cd__foot{padding:16px 18px 22px}',
      '.struga-cd__checkout{padding:17px}',
      '.struga-cd__continue{padding:12px}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  // Состояние drawer.
  var drawerEl = null;       // .struga-cd
  var drawerOverlay = null;  // .struga-cd-overlay
  var drawerOpen = false;
  var drawerCart = null;     // последний снимок корзины
  var lastFocusedEl = null;  // элемент, на котором был фокус до открытия

  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  // Создать каркас drawer (один раз). Содержимое рисуется отдельно renderDrawer().
  function buildDrawer() {
    if (drawerEl) return;
    injectDrawerStyles();

    drawerOverlay = document.createElement('div');
    drawerOverlay.className = 'struga-cd-overlay';
    drawerOverlay.setAttribute('hidden', '');
    drawerOverlay.addEventListener('click', closeDrawer);

    drawerEl = document.createElement('div');
    drawerEl.className = 'struga-cd';
    drawerEl.id = 'struga-cart-drawer';
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-modal', 'true');
    drawerEl.setAttribute('aria-label', 'Корзина');
    drawerEl.setAttribute('hidden', '');

    document.body.appendChild(drawerOverlay);
    document.body.appendChild(drawerEl);

    // Делегирование кликов внутри панели (контент перерисовывается).
    drawerEl.addEventListener('click', onDrawerClick);
  }

  // Нарисовать содержимое панели по снимку корзины.
  // mode: 'loading' — спиннер; иначе рисуем cart.
  function renderDrawer(cart, mode) {
    if (!drawerEl) return;

    if (mode === 'loading') {
      drawerEl.innerHTML =
        drawerHeadHtml(null) +
        '<div class="struga-cd__loading"><span class="struga-cd__spinner" aria-hidden="true"></span></div>';
      return;
    }

    cart = cart || { items: [], items_count: 0, total_rub: 0 };
    drawerCart = cart;
    var items = cart.items || [];

    if (items.length === 0) {
      drawerEl.innerHTML =
        drawerHeadHtml(0) +
        '<div class="struga-cd-empty">' +
        '  <span class="struga-cd-empty__mark">STRUGA</span>' +
        '  <h3 class="struga-cd-empty__title">Корзина пуста</h3>' +
        '  <p class="struga-cd-empty__text">Загляните в каталог — украшения ручной работы из серебра.</p>' +
        '  <a class="struga-cd-empty__btn" href="' + escapeAttr(SHOP_URL) + '">Перейти в магазин</a>' +
        '</div>';
      return;
    }

    var linesHtml = items.map(drawerLineHtml).join('');
    var total = parseInt(cart.total_rub, 10) || 0;
    var count = parseInt(cart.items_count, 10) || 0;

    drawerEl.innerHTML =
      drawerHeadHtml(count) +
      '<div class="struga-cd__body">' + linesHtml + '</div>' +
      '<div class="struga-cd__foot">' +
      '  <div class="struga-cd__row"><span>Товары&nbsp;(' + count + ')</span>' +
      '    <span>' + formatRub(total) + '</span></div>' +
      '  <div class="struga-cd__row"><span>Доставка</span>' +
      '    <span>рассчитаем&nbsp;при&nbsp;оформлении</span></div>' +
      '  <div class="struga-cd__total">' +
      '    <span class="struga-cd__total-label">Итого</span>' +
      '    <span class="struga-cd__total-value">' + formatRub(total) + '</span>' +
      '  </div>' +
      '  <p class="struga-cd__note">Доставку рассчитаем при оформлении</p>' +
      '  <button type="button" class="struga-cd__checkout" data-cd-checkout>Оформить заказ</button>' +
      '  <button type="button" class="struga-cd__continue" data-cd-continue>Продолжить покупки</button>' +
      '</div>';
  }

  function drawerHeadHtml(count) {
    var countHtml = '';
    if (count != null && count > 0) {
      countHtml = '<span class="struga-cd__count">' + count + ' ' + itemsWord(count) + '</span>';
    }
    return '' +
      '<div class="struga-cd__head">' +
      '  <h2 class="struga-cd__title">Корзина' + countHtml + '</h2>' +
      '  <button type="button" class="struga-cd__close" data-cd-close aria-label="Закрыть корзину">' +
           ICON_CLOSE +
      '  </button>' +
      '</div>';
  }

  function drawerLineHtml(item) {
    var basketId = parseInt(item.basket_id, 10) || 0;
    var name = escapeHtml(item.name || 'Товар STRUGA');
    var qty = parseInt(item.quantity, 10) || 1;
    var unitFmt = item.price_formatted || formatRub(item.price_rub);
    var lineFmt = item.line_formatted || formatRub(item.line_rub);
    var img = item.image_url || '';
    var productUrl = item.product_url || '';

    var imgHtml;
    if (img) {
      imgHtml = '<img class="struga-cd-line__img" src="' + escapeAttr(img) + '" alt="" ' +
        'loading="eager" decoding="async" width="150" height="150" ' +
        'onerror="this.outerHTML=\'<div class=&quot;struga-cd-line__img struga-cd-line__img--ph&quot;>STRUGA</div>\'">';
    } else {
      imgHtml = '<div class="struga-cd-line__img struga-cd-line__img--ph">STRUGA</div>';
    }

    var nameHtml = productUrl
      ? '<a class="struga-cd-line__name" href="' + escapeAttr(productUrl) + '">' + name + '</a>'
      : '<p class="struga-cd-line__name">' + name + '</p>';

    var decDisabled = qty <= 1 ? ' disabled' : '';

    return '' +
      '<div class="struga-cd-line" data-cd-line data-basket-id="' + basketId + '">' +
        imgHtml +
        '<div class="struga-cd-line__body">' +
          nameHtml +
          '<span class="struga-cd-line__unit">' + escapeHtml(unitFmt) + ' / шт</span>' +
          '<div class="struga-cd-line__row">' +
            '<span class="struga-cd-qty">' +
              '<button type="button" class="struga-cd-qty__btn" data-cd-dec' + decDisabled +
                ' aria-label="Уменьшить количество">&minus;</button>' +
              '<span class="struga-cd-qty__val" data-cd-qty aria-live="polite">' + qty + '</span>' +
              '<button type="button" class="struga-cd-qty__btn" data-cd-inc' +
                ' aria-label="Увеличить количество">+</button>' +
            '</span>' +
            '<span class="struga-cd-line__price" data-cd-line-price>' + escapeHtml(lineFmt) + '</span>' +
          '</div>' +
          '<button type="button" class="struga-cd-line__remove" data-cd-remove>Удалить</button>' +
        '</div>' +
      '</div>';
  }

  // ---- Открыть / закрыть панель ----
  function openDrawer() {
    buildDrawer();
    if (drawerOpen) return;
    drawerOpen = true;
    ensureViewIntent();
    lastFocusedEl = document.activeElement;

    drawerOverlay.removeAttribute('hidden');
    drawerEl.removeAttribute('hidden');
    // блокируем скролл фона
    document.documentElement.classList.add('struga-cd-locked');
    document.body.classList.add('struga-cd-locked');

    // двойной rAF — гарантируем переход анимации (элемент только что показан).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawerOverlay.classList.add('is-open');
        drawerEl.classList.add('is-open');
      });
    });
    // фокус на крестик для доступности
    var closeBtn = drawerEl.querySelector('[data-cd-close]');
    if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
  }

  function closeDrawer() {
    if (!drawerOpen || !drawerEl) return;
    drawerOpen = false;
    invalidateViewIntent();
    drawerOverlay.classList.remove('is-open');
    drawerEl.classList.remove('is-open');
    document.documentElement.classList.remove('struga-cd-locked');
    document.body.classList.remove('struga-cd-locked');

    // после анимации — спрятать из потока (и из tab-навигации).
    setTimeout(function () {
      if (!drawerOpen && drawerEl) {
        drawerEl.setAttribute('hidden', '');
        drawerOverlay.setAttribute('hidden', '');
      }
    }, 380);

    // вернуть фокус туда, где он был.
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      try { lastFocusedEl.focus(); } catch (e) {}
    }
    lastFocusedEl = null;
  }

  // Открыть панель и подгрузить актуальный снимок (для клика по иконке корзины).
  function renderAcceptedCart(cart) {
    renderDrawer(cart);
    updateCartBadge(cart ? cart.items_count : null);
  }

  function requestActiveCartSnapshot() {
    if (!drawerOpen || !activeViewIntent) return;
    var handle = beginViewRequest();
    cartApiGet()
      .then(function (cart) {
        completeViewRequest(handle, cart, renderAcceptedCart);
      })
      .catch(function (err) {
        failViewRequest(handle, function () {
          console.error('[STRUGA Bridge] drawer fetch failed:', err);
        });
      });
  }

  function openDrawerWithFetch() {
    buildDrawer();
    renderDrawer(null, 'loading');
    openDrawer();
    requestActiveCartSnapshot();
  }

  function applyMutationSnapshot(receipt, cart) {
    // Панель поменяла кассу: подпись зеркала страницы /cart устарела —
    // сбрасываем, следующий заход на страницу отзеркалит заново.
    if (ruCartPageMode) {
      try { sessionStorage.removeItem('struga_cart_mirror_sig'); } catch (e) {}
    }
    if (!drawerOpen || !activeViewIntent) return;
    if (receipt.viewToken === activeViewIntent.token) {
      completeMutationSnapshot(receipt.viewToken, cart, renderAcceptedCart);
      return;
    }
    // An old mutation is still a real mutation event, but may not render into
    // a reopened drawer. Refresh the current ViewIntent instead.
    requestActiveCartSnapshot();
  }

  // ---- Делегированные клики внутри панели ----
  function onDrawerClick(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return;

    // закрыть
    if (t.closest('[data-cd-close]') || t.closest('[data-cd-continue]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    // оформить заказ
    if (t.closest('[data-cd-checkout]')) {
      e.preventDefault();
      submitDrawerCheckout(t.closest('[data-cd-checkout]'));
      return;
    }

    // строка корзины — количество / удаление
    var line = t.closest('[data-cd-line]');
    if (!line) return;
    var basketId = parseInt(line.getAttribute('data-basket-id'), 10) || 0;
    if (basketId <= 0) return;

    if (t.closest('[data-cd-inc]')) {
      e.preventDefault();
      changeLineQty(line, basketId, +1);
      return;
    }
    if (t.closest('[data-cd-dec]')) {
      e.preventDefault();
      changeLineQty(line, basketId, -1);
      return;
    }
    if (t.closest('[data-cd-remove]')) {
      e.preventDefault();
      removeLine(line, basketId);
      return;
    }
  }

  // Изменить количество позиции: update.php → перерисовать панель.
  function changeLineQty(lineEl, basketId, delta) {
    if (lineEl.classList.contains('is-busy')) return;
    var qtyEl = lineEl.querySelector('[data-cd-qty]');
    var current = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
    var next = current + delta;
    if (next < 1) {
      removeLine(lineEl, basketId);
      return;
    }
    var preItem = cartItemByBasketId(drawerCart, basketId);
    var mutation = beginMutationReceipt('update', basketId, preItem, 0);
    lineEl.classList.add('is-busy');
    cartApiPost('update.php', { basket_id: basketId, quantity: next })
      .then(function (data) {
        commitMutationReceipt(mutation, data.cart);
        applyMutationSnapshot(mutation, data.cart);
      })
      .catch(function (err) {
        failMutationReceipt(mutation);
        lineEl.classList.remove('is-busy');
        console.error('[STRUGA Bridge] qty update failed:', err);
        showErrorToast(err.message || 'Не удалось обновить количество');
        requestActiveCartSnapshot();
      });
  }

  // Удалить позицию: remove.php → перерисовать панель.
  function removeLine(lineEl, basketId) {
    if (lineEl.classList.contains('is-busy')) return;
    var preItem = cartItemByBasketId(drawerCart, basketId);
    var mutation = beginMutationReceipt('remove', basketId, preItem, 0);
    lineEl.classList.add('is-busy');
    cartApiPost('remove.php', { basket_id: basketId })
      .then(function (data) {
        commitMutationReceipt(mutation, data.cart);
        applyMutationSnapshot(mutation, data.cart);
      })
      .catch(function (err) {
        failMutationReceipt(mutation);
        lineEl.classList.remove('is-busy');
        console.error('[STRUGA Bridge] remove failed:', err);
        showErrorToast(err.message || 'Не удалось удалить позицию');
        requestActiveCartSnapshot();
      });
  }

  // «Оформить заказ» из выдвижной панели — тот же единый путь /cart/checkout.php.
  // Занавес «растворение» накрывает экран (и панель), затем уходим на оформление.
  function submitDrawerCheckout(btn) {
    var cart = drawerCart || { items: [] };
    if (!cart.items || cart.items.length === 0) {
      closeDrawer();
      return;
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Оформляем…'; }
    showCurtain()
      .then(function () { return submitCartCheckout(); })
      .catch(function (err) {
        hideCurtain();
        if (btn) { btn.disabled = false; btn.textContent = 'Оформить заказ'; }
        console.error('[STRUGA Bridge] checkout submit failed:', err);
        showErrorToast('Не удалось перейти к оформлению. Обновите страницу.');
      });
  }

  // ===========================================================================
  //  B) ТОСТ-ОШИБКА (только для ошибок — успех показываем drawer'ом)
  // ===========================================================================

  function injectToastStyles() {
    if (document.getElementById('struga-cart-toast-style')) return;
    var s = document.createElement('style');
    s.id = 'struga-cart-toast-style';
    s.textContent = [
      '.struga-cart-toast{position:fixed;top:0;right:0;z-index:2147483645;width:340px;',
      'max-width:calc(100vw - 24px);margin:16px;background:#fff;border:1px solid #ececec;',
      'box-shadow:0 8px 32px rgba(0,0,0,0.16);',
      'font-family:"Jost",-apple-system,BlinkMacSystemFont,sans-serif;color:#1a1a1a;',
      'overflow:hidden;transform:translateX(420px);transition:transform .32s cubic-bezier(.2,.7,.2,1)}',
      '.struga-cart-toast.is-visible{transform:translateX(0)}',
      '.struga-cart-toast__head{display:flex;align-items:center;gap:8px;padding:14px 16px}',
      '.struga-cart-toast__check{width:18px;height:18px;flex-shrink:0;border-radius:50%;',
      'background:#8a1010;color:#fff;font-size:12px;font-weight:700;',
      'display:flex;align-items:center;justify-content:center}',
      '.struga-cart-toast__title{font-size:12px;font-weight:500;letter-spacing:.02em;line-height:1.4}',
      '.struga-cart-toast__close{margin-left:auto;border:0;background:none;cursor:pointer;',
      'color:#9a9a9a;font-size:18px;line-height:1;padding:2px 4px}',
      '@media(max-width:480px){.struga-cart-toast{width:auto;left:0;margin:12px}}'
    ].join('');
    document.head.appendChild(s);
  }

  function showErrorToast(message) {
    injectToastStyles();
    var old = document.getElementById('struga-cart-toast');
    if (old) old.remove();

    var el = document.createElement('div');
    el.id = 'struga-cart-toast';
    el.className = 'struga-cart-toast';
    el.setAttribute('role', 'alert');
    el.innerHTML = [
      '<div class="struga-cart-toast__head">',
      '  <span class="struga-cart-toast__check" aria-hidden="true">!</span>',
      '  <span class="struga-cart-toast__title">', escapeHtml(message || 'Не удалось добавить товар'), '</span>',
      '  <button type="button" class="struga-cart-toast__close" aria-label="Закрыть">&times;</button>',
      '</div>'
    ].join('');
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
    });
    function dismiss() {
      el.classList.remove('is-visible');
      setTimeout(function () { if (el.parentNode) el.remove(); }, 340);
    }
    el.querySelector('.struga-cart-toast__close').addEventListener('click', dismiss);
    setTimeout(function () { if (el.parentNode) dismiss(); }, 5000);
  }

  // ===========================================================================
  //  B) ГЛАВНЫЙ ОБРАБОТЧИК: добавить товар в корзину → выехал drawer
  // ===========================================================================
  // Единственное хранилище — Bitrix-корзина (POST /api/cart/add.php).
  // Нативный Shopify cart НЕ трогаем. Наличие/цену/имя/фото валидирует сам
  // add.php через Shopify Admin API — отдельная проверка остатков не нужна.
  function addToCart(form, submitterBtn) {
    var fd = new FormData(form);
    var variantId = fd.get('id');
    var quantity = parseInt(fd.get('quantity') || 1, 10) || 1;

    if (!variantId) {
      log('addToCart: no variant id in form, skipping interception');
      return false; // не смогли — пусть тема обработает сама
    }

    // Кастомные свойства строки (properties[...]) — гравировка, записка и т.п.
    var propsObj = {};
    fd.forEach(function (v, k) {
      if (k.indexOf('properties[') === 0 && typeof v === 'string') {
        var pm = k.match(/^properties\[(.+)\]$/);
        if (pm) propsObj[pm[1]] = v;
      }
    });

    // Индикатор на кнопке.
    var btnBusyCleanup = markButtonBusy(submitterBtn);

    // Сразу открываем панель в состоянии загрузки — мгновенный отклик на клик.
    buildDrawer();
    renderDrawer(null, 'loading');
    openDrawer();
    var mutation = beginMutationReceipt(
      'add', 0, { variant_id: String(variantId), quantity: 0 }, quantity
    );

    cartApiPost('add.php', {
      variant_id: String(variantId),
      quantity: quantity,
      properties: propsObj
    })
      .then(function (data) {
        btnBusyCleanup();
        commitMutationReceipt(mutation, data.cart);
        applyMutationSnapshot(mutation, data.cart);
        log('added to cart', data.added && data.added.variant_id,
            'cart count=', data.cart && data.cart.items_count);
      })
      .catch(function (err) {
        failMutationReceipt(mutation);
        btnBusyCleanup();
        console.error('[STRUGA Bridge] add to cart failed:', err);
        // Закрываем панель-загрузку и показываем понятную ошибку.
        closeDrawer();
        if (err.httpStatus === 409) {
          showErrorToast(err.message || 'Товара нет в наличии');
        } else {
          showErrorToast('Не удалось добавить товар. Попробуйте ещё раз.');
        }
      });

    return true; // перехватили
  }

  function markButtonBusy(btn) {
    if (!btn) return function () {};
    var prevDisabled = btn.disabled;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    return function () {
      btn.disabled = prevDisabled;
      btn.removeAttribute('aria-busy');
    };
  }

  // ===========================================================================
  //  ПЕРЕХВАТ СОБЫТИЙ
  // ===========================================================================

  // --- Это кнопка/ссылка «Купить» / «Оформить»? ---
  function isCheckoutTarget(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches && el.matches('[data-struga-bridge-trigger]')) return true;
    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      if (href === '/checkout' || href === '/checkout/' ||
          href.indexOf('/checkouts/') !== -1 ||
          /\/[a-z\-]+\/checkout(\b|\/)/i.test(href)) return true;
    }
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
      var name = (el.getAttribute('name') || '').toLowerCase();
      if (name === 'checkout') return true;
    }
    if (el.closest && el.closest('.shopify-payment-button')) return true;
    return false;
  }

  // --- Это ссылка на корзину Shopify (иконка в шапке, «view cart»)? ---
  function isCartLinkTarget(el) {
    if (!el || el.nodeType !== 1 || el.tagName !== 'A') return false;
    var href = (el.getAttribute('href') || '').split('?')[0].split('#')[0];
    // routes.cart_url у Shopify = "/cart". Локализованный префикс: "/ru/cart" и т.п.
    return href === '/cart' || href === '/cart/' || /\/[a-z\-]{2,5}\/cart\/?$/i.test(href);
  }

  // --- Это кнопка «В корзину» (submit name=add)? ---
  function isAddToCartButton(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName !== 'BUTTON' && el.tagName !== 'INPUT') return false;
    if ((el.getAttribute('name') || '').toLowerCase() !== 'add') return false;
    if ((el.getAttribute('type') || 'submit').toLowerCase() !== 'submit') return false;
    return true;
  }

  function findAncestor(start, testFn, maxDepth) {
    var el = start, depth = 0;
    while (el && el.nodeType === 1 && depth < (maxDepth || 6)) {
      if (testFn(el)) return el;
      el = el.parentElement;
      depth++;
    }
    return null;
  }

  // --- CLICK (capture) ---
  function onClick(e) {
    if (e.defaultPrevented) return;

    // 0) Клик ВНУТРИ нашей панели — пусть обработает onDrawerClick, не мешаем.
    if (drawerEl && (drawerEl.contains(e.target) ||
        (drawerOverlay && drawerOverlay.contains(e.target)))) {
      return;
    }

    // 1) Ссылка на корзину Shopify → открыть наш drawer.
    var cartLink = findAncestor(e.target, isCartLinkTarget, 4);
    if (cartLink) {
      log('intercepted cart link → open drawer');
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openDrawerWithFetch();
      return;
    }

    // 2) «Купить» / «Оформить». Триггер внутри карточки товара (форма
    //    /cart/add) → «Купить» (этот товар → checkout). Иначе → «Оформить»
    //    всей корзины.
    var checkoutEl = findAncestor(e.target, isCheckoutTarget, 6);
    if (checkoutEl) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var pForm = checkoutEl.closest ? checkoutEl.closest('form') : null;
      var pAction = pForm ? (pForm.getAttribute('action') || '').toLowerCase() : '';
      if (pForm && pAction.indexOf('/cart/add') !== -1) {
        log('intercepted "buy now" click → add + checkout');
        buyNow(pForm, (checkoutEl.tagName === 'BUTTON' || checkoutEl.tagName === 'INPUT') ? checkoutEl : null);
      } else {
        log('intercepted checkout click → cart checkout');
        goToCartCheckout();
      }
      return;
    }

    // 3) «В корзину» (кнопка name=add). Перехватываем клик в capture, ДО
    //    custom element <product-form> темы — он не успеет открыть свой drawer.
    var addBtn = findAncestor(e.target, isAddToCartButton, 4);
    if (addBtn) {
      var form = addBtn.closest('form');
      var actionL = form ? (form.getAttribute('action') || '').toLowerCase() : '';
      // Только формы /cart/add — не трогаем посторонние формы с кнопкой name=add.
      if (form && (actionL === '/cart/add' || /\/cart\/add(\?.*)?$/.test(actionL) || actionL.indexOf('/cart/add') !== -1)) {
        log('intercepted "add to cart" click');
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        addToCart(form, addBtn);
        return;
      }
    }
  }

  // --- SUBMIT (capture) — страховка, если submit прошёл мимо click ---
  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || e.defaultPrevented) return;
    var actionLower = (form.getAttribute('action') || '').toLowerCase();
    var submitter = e.submitter;

    // /cart/add форма.
    if (actionLower === '/cart/add' || /\/cart\/add(\?.*)?$/.test(actionLower) || actionLower.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      // Buy-it-now / явный checkout-триггер → «Купить» (этот товар → checkout).
      if (submitter && (
        submitter.getAttribute('name') === 'checkout' ||
        (submitter.matches && submitter.matches('[data-struga-bridge-trigger]')) ||
        (submitter.closest && submitter.closest('.shopify-payment-button'))
      )) {
        log('intercepted /cart/add submit (buy it now)');
        buyNow(form, (submitter.tagName === 'BUTTON' || submitter.tagName === 'INPUT') ? submitter : null);
        return;
      }
      // Обычное «В корзину» (в т.ч. submit без submitter — Enter в поле)
      // → Bitrix-корзина + drawer.
      log('intercepted /cart/add submit (add to cart)');
      addToCart(form, submitter || form.querySelector('button[name="add"]'));
      return;
    }

    // /cart форма — submit name=checkout → checkout всей корзины.
    if (actionLower === '/cart' || actionLower.endsWith('/cart')) {
      if (submitter && submitter.getAttribute('name') === 'checkout') {
        log('intercepted /cart submit → cart checkout');
        e.preventDefault();
        e.stopPropagation();
        goToCartCheckout();
      }
      return;
    }

    // Прямая /checkout форма.
    if (actionLower === '/checkout' || actionLower.endsWith('/checkout') ||
        actionLower.indexOf('/checkouts/') !== -1) {
      log('intercepted /checkout submit → cart checkout');
      e.preventDefault();
      e.stopPropagation();
      goToCartCheckout();
    }
  }

  // --- Клавиша Escape — закрыть drawer ---
  function onKeydown(e) {
    if (!drawerOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      e.preventDefault();
      closeDrawer();
    }
  }

  // ===========================================================================
  //  bfcache + установка
  // ===========================================================================

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      log('bfcache restore — cleanup');
      // Сбрасываем drawer: при возврате «Назад» панель не должна висеть открытой.
      // Делаем это ДО растворения занавеса — пользователь не видит «схлопывание».
      if (drawerOpen) {
        drawerOpen = false;
        invalidateViewIntent();
        if (drawerEl) {
          drawerEl.classList.remove('is-open');
          drawerEl.setAttribute('hidden', '');
        }
        if (drawerOverlay) {
          drawerOverlay.classList.remove('is-open');
          drawerOverlay.setAttribute('hidden', '');
        }
        document.documentElement.classList.remove('struga-cd-locked');
        document.body.classList.remove('struga-cd-locked');
      }
      drawerCart = null;
      cartCsrf = null;
      // Обновим счётчик корзины — он мог измениться.
      ensureCartCsrf();
      // Возврат с оформления: страница восстановлена из памяти браузера вместе
      // с поднятым кремовым занавесом (его проявили перед уходом). Плавно
      // растворяем — карточка мягко проступает. Нет занавеса → обычный «Назад».
      if (curtainEl && curtainEl.classList.contains('is-visible')) {
        hideCurtain();
      }
    }
  });

  function install() {
    if (INSTALLED) return;
    INSTALLED = true;
    // capture phase — перехват ДО theme JS и custom elements.
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('keydown', onKeydown, false);
    // Сразу подтягиваем счётчик нашей корзины (и CSRF-токен на будущее).
    ensureCartCsrf();
    // Bridge работает только со своей Bitrix-корзиной. Нативный Shopify cart
    // гасим один раз за сессию вкладки — чтобы там не оставалось «мусорных»
    // позиций. Исключение — сама страница /cart: там нативная корзина служит
    // зеркалом состава кассы, и фирменный вид рисует тема (Дмитрий, 27.07).
    if (ruCartPageMode) {
      mirrorRuCartPage();
    } else {
      neutralizeShopifyCart();
    }
    log('installed; enabled=', cfg.enabled, 'shop=', SHOP, 'cart_api=', CART_API);
  }

  // ===========================================================================
  //  СТРАНИЦА КОРЗИНЫ ВИТРИНЫ (.ru): нативная корзина = зеркало кассы.
  //  Источник истины не меняется — заказ рождается из корзины Битрикса.
  //  Нативная корзина нужна ТОЛЬКО затем, чтобы тема нарисовала фирменную
  //  страницу /cart (та же вёрстка, что strugadesign.com/cart).
  // ===========================================================================

  function ruCartSigOf(map) {
    var keys = Object.keys(map).sort();
    if (!keys.length) return 'empty';
    return keys.map(function (k) { return k + 'x' + map[k]; }).join(',');
  }
  function ruCartWantFromBitrix(cart) {
    var want = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var vid = String(it.variant_id || '');
      if (!vid) return;
      want[vid] = (want[vid] || 0) + (parseInt(it.quantity, 10) || 1);
    });
    return want;
  }
  function ruCartHaveFromNative(native) {
    var have = {};
    ((native && native.items) || []).forEach(function (it) {
      var vid = String(it.id || '');
      if (!vid) return;
      have[vid] = (have[vid] || 0) + (parseInt(it.quantity, 10) || 1);
    });
    return have;
  }
  function fetchNativeCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  // Зеркалирование при открытии /cart. Направление решает подпись состава в
  // sessionStorage: подпись кассы не совпадает с запомненной — этот состав ещё
  // не зеркалили (касса → нативная, одна перезагрузка); совпадает, а нативная
  // разошлась — человек правил состав прямо на странице (нативная → касса,
  // без перезагрузки). Совпадение составов — естественный стоп цикла.
  function mirrorRuCartPage() {
    Promise.all([
      cartApiGet().catch(function () { return null; }),
      fetchNativeCart().catch(function () { return null; })
    ]).then(function (pair) {
      var bitrix = pair[0];
      var native = pair[1];
      if (!bitrix) {
        log('ru cart mirror: cart api unavailable — fallback to pay cart page');
        try { window.location.replace('https://pay.strugadesign.ru/cart/'); } catch (e) {}
        return;
      }
      var want = ruCartWantFromBitrix(bitrix);
      var have = ruCartHaveFromNative(native);
      if (ruCartSigOf(want) === ruCartSigOf(have)) {
        log('ru cart mirror: in sync');
        return;
      }
      var sig = ruCartSigOf(want);
      var stored = null;
      try { stored = sessionStorage.getItem('struga_cart_mirror_sig'); } catch (e) {}
      if (stored === sig) {
        log('ru cart mirror: page edited — pushing native composition to cart api');
        pushNativeToBitrix(bitrix, have).then(function () {
          try { sessionStorage.setItem('struga_cart_mirror_sig', ruCartSigOf(have)); } catch (e) {}
        });
        return;
      }
      try { sessionStorage.setItem('struga_cart_mirror_sig', sig); } catch (e) {}
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', cache: 'no-store' })
        .then(function () {
          var ids = Object.keys(want);
          if (!ids.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: ids.map(function (k) {
                return { id: parseInt(k, 10), quantity: want[k] };
              })
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('mirror_add_http_' + r.status);
            return r.json();
          });
        })
        .then(function () { window.location.reload(); })
        .catch(function (err) {
          console.error('[STRUGA Bridge] ru cart mirror failed:', err);
          try { window.location.replace('https://pay.strugadesign.ru/cart/'); } catch (e) {}
        });
    });
  }

  // Довести корзину Битрикса до состава нативной (человек правил страницу).
  // Мутации идут последовательно через существующую очередь cartApiPost —
  // порядок применения на сервере однозначен.
  function pushNativeToBitrix(bitrixCart, have) {
    var ops = [];
    var seen = {};
    ((bitrixCart && bitrixCart.items) || []).forEach(function (it) {
      var vid = String(it.variant_id || '');
      var q = have[vid];
      if (!q) {
        ops.push(['remove.php', { basket_id: it.basket_id }]);
      } else if (q !== (parseInt(it.quantity, 10) || 1)) {
        ops.push(['update.php', { basket_id: it.basket_id, quantity: q }]);
      }
      seen[vid] = true;
    });
    Object.keys(have).forEach(function (vid) {
      if (!seen[vid]) ops.push(['add.php', { variant_id: vid, quantity: have[vid] }]);
    });
    if (!ops.length) return Promise.resolve();
    return ops.reduce(function (p, op) {
      return p.then(function () { return cartApiPost(op[0], op[1]); });
    }, Promise.resolve()).catch(function (err) {
      console.error('[STRUGA Bridge] ru cart push failed:', err);
    });
  }

  // Перед оформлением со СТРАНИЦЫ корзины: заказ обязан совпасть с тем, что
  // человек видит. Кассу правила панель (подпись сброшена) — она и есть истина,
  // не откатываем. Любая ошибка сверки НЕ блокирует оформление: чекаут сам
  // показывает состав ещё раз.
  function reconcileRuCartBeforeCheckout() {
    if (!ruCartPageMode) return Promise.resolve();
    return Promise.all([
      cartApiGet().catch(function () { return null; }),
      fetchNativeCart().catch(function () { return null; })
    ]).then(function (pair) {
      var bitrix = pair[0];
      var native = pair[1];
      if (!bitrix || !native) return;
      var want = ruCartWantFromBitrix(bitrix);
      var have = ruCartHaveFromNative(native);
      if (ruCartSigOf(want) === ruCartSigOf(have)) return;
      var stored = null;
      try { stored = sessionStorage.getItem('struga_cart_mirror_sig'); } catch (e) {}
      if (stored !== ruCartSigOf(want)) return;
      return pushNativeToBitrix(bitrix, have);
    }).catch(function () { /* оформление важнее синхронизации */ });
  }

  // Очистить нативный Shopify cart (fire-and-forget, один раз за сессию вкладки).
  function neutralizeShopifyCart() {
    try {
      if (sessionStorage.getItem('struga_sc_cleared') === '1') return;
    } catch (e) { /* sessionStorage недоступен — чистим всё равно */ }
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', cache: 'no-store' })
      .then(function () {
        try { sessionStorage.setItem('struga_sc_cleared', '1'); } catch (e) {}
        log('shopify native cart neutralized');
      })
      .catch(function () { /* не критично — Shopify cart мы всё равно не читаем */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
